import React from 'react'
import Index from '../views/dashboard/index'
// import { Switch, Route } from 'react-router-dom'
// user
import UserProfile from '../views/dashboard/app/user-profile';
import UserAdd from '../views/dashboard/app/user-add';
import Google from '../views/dashboard/maps/google';

//extra
// import PrivacyPolicy from '../views/dashboard/extra/privacy-policy';
// import TermsofService from '../views/dashboard/extra/terms-of-service';

//TransitionGroup
// import { TransitionGroup, CSSTransition } from "react-transition-group";
//Special Pages

import Default from '../layouts/dashboard/default';
import ExpenseList from '../views/dashboard/expenses/ExpenseList';
import LeavesList from '../views/dashboard/leaves/LeavesList';
import EmployeeList from '../views/dashboard/employee/EmployeeList';
import EmployeeProfile from '../views/dashboard/app/employee-profle';
import TripsList from '../views/dashboard/trips/TripList';
import TripDetails from '../views/dashboard/trips/Tripdetails';
import DealersList from '../views/dashboard/dealers/DealersList';
import ProductList from '../views/dashboard/products/ProductList';
import OrganisationProfile from '../views/dashboard/app/org-profile';
import Error500 from '../views/dashboard/errors/error500';
import TripSummary from '../views/dashboard/trips/TripSummary';
import AttendenceSheet from '../views/dashboard/attendence/AttendenceSheet';
import OrderDetails from '../views/dashboard/order/orderDetails';
import OrderList from '../views/dashboard/order/OrderList';
import OrderGuard from '../views/dashboard/order/OrderGuard';
import PaymentList from '../views/dashboard/payment/PaymentList';
import DealerVisits from '../views/dashboard/dealers/DealerVisits';
import DealerProfile from '../views/dashboard/dealers/DealerDetails';
import OrgSettings from '../views/dashboard/app/org-settings';
import Visuals from '../views/dashboard/visuals/Visuals';
import OfferList from '../views/dashboard/offers/OfferList';
import OrderDetailsV2 from '../views/dashboard/order/OrderDetailsV2';
import PerformanceAnalysis from '../views/dashboard/performance/PerformanceAnalysis';


export const DefaultRouter = [
    {
        path: '/',
        element: <Default />,
        children: [
            {
                path: 'dashboard',
                element: <Index />
            },
            {
                path: 'dashboard/users',
                element: <EmployeeList />
            },
            {
                path: 'dashboard/users/:id',
                element: <EmployeeProfile />
            },
            {
                path: 'dashboard/trips',
                element: <TripsList />
            },
            {
                path: 'dashboard/orders',
                element: <OrderGuard><OrderList /></OrderGuard>
            },
            {
                path: 'dashboard/trip-summary',
                element: <TripSummary />
            },
            {
                path: 'dashboard/attendence-sheet',
                element: <AttendenceSheet />
            },
            {
                path: 'dashboard/trips/:id',
                element: <TripDetails />
            },
            {
                path: 'dashboard/orderDetails/:id',
                element: <OrderGuard><OrderDetailsV2 /></OrderGuard>
            },
            {
                path: 'dashboard/orders/:id',
                element: <OrderGuard><OrderDetailsV2 /></OrderGuard>
            },
            {
                path: 'dashboard/products',
                element: <ProductList />
            },
            {
                path: 'dashboard/products/list',
                element: <ProductList />
            },
            {
                path: 'dashboard/products/visuals',
                element: <Visuals />
            },
            {
                path: 'dashboard/products/offers',
                element: <OfferList />
            },
            {
                path: 'dashboard/dealers',
                element: <DealersList />
            },
            {
                path: 'dashboard/dealers/list',
                element: <DealersList />
            },
            {
                path: 'dashboard/dealers/:id',
                element: <DealerProfile />
            },
            {
                path: 'dashboard/dealers/visits',
                element: <DealerVisits />
            },
            {
                path: 'dashboard/expenses',
                element: <ExpenseList />
            },
            {
                path: 'dashboard/payment',
                element: <PaymentList />
            },
            {
                path: 'dashboard/leaves',
                element: <LeavesList />
            },
            {
                path: 'dashboard/performance-analysis',
                element: <PerformanceAnalysis />
            },
            {
                path: 'dashboard/map',
                element: <Google />
            },
            // {
            //     path: 'dashboard/special-pages/billing',
            //     element: <Billing />
            // },
            // {
            //     path: 'dashboard/special-pages/calender',
            //     element: <Calender />
            // },
            // {
            //     path: 'dashboard/special-pages/kanban',
            //     element: <Kanban />
            // },
            // {
            //     path: 'dashboard/special-pages/pricing',
            //     element: <Pricing />
            // },
            // {
            //     path: 'dashboard/special-pages/timeline',
            //     element: <Timeline />
            // },
            // {
            //     path: 'dashboard/special-pages/rtl-support',
            //     element: <RtlSupport/>,
            // },
            {
                path: 'dashboard/app/user-profile',
                element: <UserProfile />
            },
            {
                path: 'dashboard/org-profile',
                element: <OrganisationProfile />
            },
            {
                path: 'dashboard/settings',
                element: <OrgSettings />
            }
            // {
            //     path: 'dashboard/app/user-list',
            //     element: <UserList />
            // },
            // {
            //     path: 'dashboard/admin/admin',
            //     element: <Admin />
            // },
            // Widget
            // {
            //     path: 'dashboard/widget/widgetbasic',
            //     element: <Widgetbasic />
            // },
            // {
            //     path: 'dashboard/widget/widgetchart',
            //     element: <Widgetchart />
            // },
            // {
            //     path: 'dashboard/widget/widgetcard',
            //     element: <Widgetcard />
            // },
            // Map
            // {
            //     path: 'dashboard/map',
            //     element: <Google />
            // },
            // {
            //     path: 'dashboard/map/vector',
            //     element: <Vector />
            // },
            // Form
            // {
            //     path: 'dashboard/form/form-element',
            //     element: <FormElement />
            // },
            // {
            //     path: 'dashboard/form/form-wizard',
            //     element: <FormWizard />
            // },
            // {
            //     path: 'dashboard/form/form-validation',
            //     element: <FormValidation />
            // },
            // Table
            // {
            //     path: 'dashboard/table/bootstrap-table',
            //     element: <BootstrapTable />
            // },
            // {
            //     path: 'dashboard/table/table-data',
            //     element: <TableData />
            // },
            // Icon
            // {
            //     path: 'dashboard/icon/solid',
            //     element: <Solid />
            // },
            // {
            //     path: 'dashboard/icon/outline',
            //     element: <Outline />
            // },
            // {
            //     path: 'dashboard/icon/dual-tone',
            //     element: <DualTone />
            // }
        ]
    }
]
// const DefaultRouter = () => {
//     return (
//         <TransitionGroup>
//             <CSSTransition classNames="fadein" timeout={300}>
//                 <Switch>
//                     <Route path="/dashboard" exact component={Index} />
//                     {/* user */}
//                     <Route path="/dashboard/app/user-profile"     exact component={UserProfile} />
//                     <Route path="/dashboard/app/user-add"         exact component={UserAdd}/>
//                     <Route path="/dashboard/app/user-list"        exact component={UserList}/>
//                     <Route path="/dashboard/app/user-privacy-setting" exact component={userProfileEdit}/>
//                      {/* widget */}
//                      <Route path="/dashboard/widget/widgetbasic"   exact component={Widgetbasic}/>
//                      <Route path="/dashboard/widget/widgetcard"    exact component={Widgetcard}/>
//                      <Route path="/dashboard/widget/widgetchart"   exact component={Widgetchart}/>
//                      {/* icon */}
//                      <Route path="/dashboard/icon/solid"           exact component={Solid}/>
//                      <Route path="/dashboard/icon/outline"         exact component={Outline}/>
//                      <Route path="/dashboard/icon/dual-tone"       exact component={DualTone}/>
//                      {/* From */}
//                      <Route path="/dashboard/form/form-element"    exact component={FormElement}/>
//                      <Route path="/dashboard/form/form-validation" exact component={FormValidation}/>
//                      <Route path="/dashboard/form/form-wizard"     exact component={FormWizard}/>
//                      {/* table */}
//                      <Route path="/dashboard/table/bootstrap-table" exact component={BootstrapTable}/>
//                      <Route path="/dashboard/table/table-data"      exact component={TableData}/>
//                      {/*special pages */}
//                      <Route path="/dashboard/special-pages/billing" exact component={Billing}/>
//                      <Route path="/dashboard/special-pages/kanban" exact component={Kanban}/>
//                      <Route path="/dashboard/special-pages/pricing" exact component={Pricing}/>
//                      <Route path="/dashboard/special-pages/timeline" exact component={Timeline}/>
//                      <Route path="/dashboard/special-pages/calender" exact component={Calender}/>
//                      {/* map */}
//                      <Route path="/dashboard/map/vector" exact component={Vector}/>
//                      <Route path="/dashboard/map/google" exact component={Google}/>
//                      {/* extra */}
//                      <Route path="/dashboard/extra/privacy-policy" exact component={PrivacyPolicy}/>
//                      <Route path="/dashboard/extra/terms-of-service" exact component={TermsofService}/>
//                      {/*admin*/}
//                      <Route path="/dashboard/admin/admin" exact component={Admin}/>
//                 </Switch>
//             </CSSTransition>
//         </TransitionGroup>
//     )
// }

// export default DefaultRouter
